import { CSSProperties } from "react";

export function BarchartIcon(props: {
  style?: CSSProperties;
  inactive?: boolean;
  size?: number;
}) {
  const size = props.size === undefined ? 20 : props.size;
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={props.inactive ? "0.5" : "1"}>
        <rect x="1" y="4" width="4" height="12" fill="currentColor" />
        <rect x="8" y="8" width="4" height="8" fill="currentColor" />
        <rect x="15" y="2" width="4" height="14" fill="currentColor" />
      </g>
    </svg>
  );
}
